<template>
  <div class="container">
    <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
      <i class="el-icon-s-fold" ></i>
      <el-breadcrumb separator="/" >
        <el-breadcrumb-item >个人中心</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
      <div class="base-message">
        <dv-border-box-12 >
          <div style="padding: 6px 6px 20px 5px;">
            <div class="header-common">
              <div class="header-common-left">
                <div class="title">用户信息</div>
              </div>
              <header class="header-common-right">
                <el-button
                  size="mini"
                  type="primary"
                  class="right-button"
                  @click="logout()"
                  >
                  退出
                </el-button>
              </header>
            </div>
            <el-descriptions
            class="margin-top"
            title=""
            :column="2"
            border
            :contentStyle="contentStyle"
            :labelStyle='labelStyle'
            >
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-set-up"></i>
                  所属分组
                </template>
                {{groupName}}
              </el-descriptions-item>
              <el-descriptions-item >
                <template slot="label">
                  <i class="el-icon-user"></i>
                  账号名
                </template>
                {{username}}
              </el-descriptions-item>
              <el-descriptions-item >
                <template slot="label">
                  <i class="el-icon-user"></i>
                  真实姓名
                </template>
                {{nickname}}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-mobile-phone"></i>
                  手机号
                </template>
                {{phone}}
              </el-descriptions-item>
              <!-- <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-s-flag"></i>
                  权限
                </template>
                设备监控、耗材告警、设备管理、耗材管理、知识库管理、用户管理、数据浏览
              </el-descriptions-item> -->
            </el-descriptions>
          </div>
        </dv-border-box-12>
      </div>


     <div class="modify">
        <dv-border-box-12>
          <div style="padding: 6px;">
            <div class="header-common">
              <div class="header-common-left">
                <div class="title">修改密码</div>
              </div>
            </div>
            <el-form
            ref="form"
            :model="form"
            :rules='rules'
            style="width: 50%;padding: 30px 0px;" label-width="120px">
              <el-form-item label="原始密码" prop="password">
                <el-input id="password" v-model="form.password"></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newPassword" style="margin-top: 30px;">
                <el-input id="newPassword" v-model="form.newPassword" ></el-input>
              </el-form-item>
              <!-- <el-form-item label="确认密码" prop="twicePassword" style="margin-top: 30px;">
                <el-input v-model="form.twicePassword" >
                </el-input>
              </el-form-item> -->
              <el-form-item label="手机验证码" prop="phoneCode"  class="checkCode" style="margin-top: 30px;">
                <el-input
                  id="phoneCode"
                  v-model="form.phoneCode"
                  paceholder="验证码"
                  style="width: 100%;"
                  oninput="value=value.replace(/[^\d]/g,'')">
                </el-input>
                <el-button
                  size="mini"
                  style="margin-top: -49px;margin-right: 5px;float: right;position: relative;"
                  @click.stop="getCode"
                  v-if="show"
                  >获取验证码</el-button>
                <el-button
                size="mini"
                type="primary"
                style="margin-top: -49px;margin-right: 5px;float: right;position: relative;"
                v-if="!show"
                disabled
                >{{ count }}秒后重发</el-button>
              </el-form-item>
              <el-form-item style="margin-top: 40px;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="submitForm('form')"
                  class="action-button">
                  保存
                </el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="resetForm('form')"
                  class="action-button">
                  重置
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </dv-border-box-12>

      </div>
  </div>
</template>

<script>

  export default{
    data() {
      return{
        contentStyle:{
          'border':'1px solid #1A3F81',
          'backgroung-color':'transparent',
          'color':'#fff',
          'border-bottom':'0px',
          'border-right':'0px',
        },
        labelStyle:{
          'width': '120px',
          'height': '20px',
          'font-size': '14px',
          'font-weight': 'bold',
          'color': '#00FFFF',
          // 'line-height': '50px',
          'background-color':'transparent',
          'border':'1px solid #1A3F81',
          'border-bottom':'0px',
          // 'border-left':'0px',
        },
        groupName:'',
        username:'',
        nickname:'',
        phone:'',
        form: {
          // groupName:'',
          // username:'',
          // nickname:'',
          // phone:'',
          password: '',
          newPassword: '',
          phoneCode:''
        },
        rules:{
          password: [
            {required: true, message:'原始密码不能为空',trigger:'blur'},
          ],
          newPassword: [
            {required: true, message: '请输入新密码',trigger:'blur'}
          ],
          phoneCode:[
            {required: true, message: '请输入验证码',trigger:'blur'},
            {
              pattern:/^-?[0-9]\d*$/,
              message:'请输入6位数字验证码'
            }
          ],
        },
        show:true,
        count: "",
        timer: null,
      }
    },
    methods:{
      //验证码 倒计时
      countDown() {
        let TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      },
      isMobile:function(value){
        return /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
      },
      getCode(){
        if (!this.phone) {
          this.$message('请输入手机号');
          return;
        }

        if (this.phone.length !== 11) {
          this.$message('请输入11位手机号');
          return;
        }

        if(!this.isMobile(this.phone)){
          this.$message('手机号码格式错误');
          return;
        }

        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/auth/sms';
        const data = {
          "phone":this.phone,
          "type":2
        }

        this.$http({
          method:'POST',
          url:url,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                message:'验证码已发送',
                type:'success'
              })
              this.countDown();
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      modifyPassword(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/setting/changepwd';
        const data = {
          "oldPassword":this.form.password,
          "newPassword":this.form.newPassword,
          "authCode":this.form.phoneCode
        }

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                message:'密码修改成功',
                type:'success'
              })
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      resetForm(form){
        this.$refs[form].resetFields();
      },
      submitForm(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            this.modifyPassword();
            } else {
              console.log('error submit!!');
              return false;
            }
          });
      },
      logout() {
        this.$confirm('此操作将退出登录，是否继续？','提示',{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          type:'warning'
        }).then(() => {
          this.logoutAction();
        }).catch(() => {
          this.$message({
            type:'info',
            message:'取消退出登录'
          })
        })
      },
      logoutAction(){

        this.$store.commit('LOGOUT')
        this.$router.replace('/login')
      },
      getUserMessage(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/setting/userinfo';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              // alert(JSON.stringify(obj.data))
              //获取信息
              // this.form.groupName = obj.data.groupName;
              // this.form.username = obj.data.username;
              // this.form.nickname = obj.data.nickname;
              // this.form.phone = obj.data.phone;

              this.groupName = obj.data.groupName;
              this.username = obj.data.username;
              this.nickname = obj.data.nickname;
              this.phone = obj.data.phone;

              // var userInfo = {
              //   'groupName':obj.data.groupName,
              //   'username':obj.data.username,
              //   'nickname':obj.data.nickname,
              //   'phone':obj.data.phone
              //   }

              // this.$store.commit('setUserInfo',userInfo);
              this.$store.commit('setPermission',obj.data.permissions);
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
          if(err.response.status == 401){
            this.$router.replace('/login')
          }
        })
      },

    },
    mounted() {
      this.getUserMessage();
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    }

  }
</script>


<style lang="scss" scoped>
.container{
  height: 100%;
  margin-top: $header-height;

  .base-message{
    margin-top: 10px;
  }

  .modify{
    margin-top: 20px;
    .action-button{
      width: 120px;
      height: 40px;
      background: #FAFAFA;
      border: 1px solid rgba(0,144,255,0.84);
      border-radius: 20px;
      background-color: #20478D;
      font-size: 14px;
      font-weight: 400;
      color: #00DEFF;
    }
  }

  .header-common{
    width: 100%;
    height: 45px;
    border-radius: 12px 12px 0 0 ;
    background: linear-gradient(-90deg, #001940, #1564BE);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .header-common-left{

      font-size: 20px;

      font-weight: bold;
      color: #FEFEFE;
      margin-left: 21px;
    }

    .header-common-right{

      .right-button{
        margin-right: 10px;
        width: 100px;
        height: 36px;
        background: RGBA(7, 35, 90, 1);
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 18px;
        color: #00DEFF;
        font-size: 15px;
        font-weight: solid;
      }
    }
  }


}
</style>



// WEBPACK FOOTER //
// src/view/center/center.vue